import React from 'react';
import Layout, { LayoutItem } from '../components/Layout';
import Ad from '../../components/Ad';
const withLayout = Component => {
  const WithLayout = props => (
    <Layout>
      <Component layoutItem={LayoutItem} {...props} />
      <LayoutItem area="left-bottom">
        <Ad />{' '}
      </LayoutItem>
      <LayoutItem area="right-bottom">
        <Ad />
      </LayoutItem>
    </Layout>
  );
  return WithLayout;
};
export default withLayout;
